import { TranslatedCopy } from './TranslatedCopy';

export const locales = [
  { label: new TranslatedCopy({ id: 'languagePicker.lang.english' }).toString('en'), value: 'en_us' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.french' }).toString('fr'), value: 'fr_fr' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.german' }).toString('de'), value: 'de_de' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.italian' }).toString('it'), value: 'it_it' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.portuguese' }).toString('pt'), value: 'pt_pt' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.spanish' }).toString('es'), value: 'es_es' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.turkish' }).toString('tr'), value: 'tr_tr' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.simplifiedChinese' }).toString('cn'), value: 'cn_cn' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.traditionalChinese' }).toString('tc'), value: 'tc_cn' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.japanese' }).toString('ja'), value: 'ja_ja' },
  { label: new TranslatedCopy({ id: 'languagePicker.lang.korean' }).toString('ko'), value: 'ko_ko' }
];
